<template>
  <div
    v-if="scene"
    :style="'flex: 1 1 1px;'"
    style="display: relative; height: 120px; border-radius: 4px">
    <div v-if="deluge.items[scene.did]">
      <v-img
        height="120"
        width="220"
        dark
        cover
        style="
          border-radius: 4px;
          overflow: hidden;
          backgroung-clip: context-box;
          z-index: 2;
          background: #5c5c5d;
        "
        :src="asset_img">
        <div style="opacity: 0.97; display: flex; height: 100%">
          <div
            v-if="state.channelOnAirEditMode || editMode"
            class="grabber transbackground text-center"
            style="
              display: inline-block;
              height: 100%;
              width: 32px;
              cursor: grab;
              z-index: 1;
              flex-shrink: 0;
              display: flex;
            "
            :style="
              avg_color ? 'background:' + avg_color : 'background:var(--v-cardColor-base)'
            ">
            <v-spacer />
            <v-divider
              style="color: white"
              class="mx-1"
              inset
              vertical />
            <v-divider
              style="color: white; margin-right: 1px; margin-left: 1px"
              inset
              vertical />
            <v-divider
              style="color: white"
              class="mx-1"
              inset
              vertical />
            <v-spacer />
          </div>
          <div
            @mouseenter="state.sceneConditionSummary = deluge.items[scene.did]"
            @mouseleave="state.sceneConditionSummary = false"
            :class="
              !state.channelOnAirEditMode && !editMode ? 'py-2 px-4' : 'pa-2'
            "
            style="
              border-radius: 0px 4px 4px 0px;
              width: 100%;
              display: inline-block;
              height: 100%;
              box-shadow: inset 0 0 15px #0000004d;
              display: flex;
              flex-direction: column;
              gap: 6px;
            ">
            <div
              v-if="deluge.items[scene.did]"
              @click="$emit('OpenQueue', scene)"
              class="pa-2 nice"
              :style="`
                  border-radius: 5px;
                  cursor: pointer;
                  flex-grow: 1;
                  height: 66px;
                  display: flex;
                  flex-grow: 1;
                  background: ${color()};
                  flex-direction: column;
                  justify-content: space-between;
                  max-width: ${
                    state.channelOnAirEditMode || editMode ? '170px' : '194px'
                  };
                  `">
              <div
                class="text-truncate"
                style="font-size: 14px; cursor: pointer"
                :style="
                  avg_color ? 'background:' + avg_color : 'background:var(--v-cardColor-base)'
                ">
                <v-icon
                  size="large"
                  class="mr-2">
                  mdi-playlist-play
                </v-icon>
                {{ deluge.items[scene.did].name }}
              </div>
              <div
                class="text-truncate"
                style="font-size: 13px; cursor: pointer; opacity: 0.5"
                v-if="scene.items.length > 0">
                <div
                  v-if="deluge.items[scene.items[scene.index].did]"
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  ">
                  <v-icon
                    class="mr-1"
                    small>
                    mdi-arrow-right-bottom
                  </v-icon>
                  {{ deluge.items[scene.items[scene.index].did].name }}
                </div>
              </div>
              <div
                class="text-truncate"
                style="font-size: 11px; cursor: pointer; opacity: 0.5"
                v-else>
                <v-icon
                  class="mr-1"
                  small>
                  mdi-arrow-right-bottom
                </v-icon>
                Empty...
              </div>
            </div>
            <div class="button-container text-subtitle-2">
              <!-- Go live Button -->
              <div
                title="Switch to this Scene"
                @click="force_scene()"
                v-if="!scene.live && !state.channelOnAirEditMode && !editMode"
                class="actionbtn nice py-1"
                :style="
                  avg_color ? 'background:' + avg_color : 'background:var(--v-cardColor-base);'
                ">
                <v-icon
                  :color="current && !scene.live ? 'primary' : '#ffffff47'"
                  v-if="!loading_live">
                  mdi-chevron-double-right
                </v-icon>
                <v-progress-circular
                  v-if="loading_live"
                  indeterminate
                  color="white"
                  :size="18"
                  :width="2"></v-progress-circular>
              </div>
              <!-- Go Live Button - Live Mode -->

              <div
                title="This Scene is currently playing"
                v-else-if="!state.channelOnAirEditMode && !editMode"
                :style="`cursor:pointer;border-radius:4px; ;border-radius: 4px;box-shadow: 0px 0px 8px 8px ${$vuetify.theme.themes.dark.primary}40 ;`"
                class="actionbtn nice py-1 transbackground_active">
                <v-icon color="white">mdi-chevron-double-right</v-icon>
              </div>
              <!-- End Go Live Button -->
              <div
                title="Open Scene Play Conditions"
                v-if="
                  scene.valid &&
                  scene.live &&
                  Object.keys(
                    deluge.items[scene.did].conditions.play_conditions
                  ).length > 0
                "
                @click="emit('OpenPlayConditions')"
                :style="`float: left;cursor:pointer;box-shadow: 0px 0px 8px 8px ${$vuetify.theme.themes.dark.primary}40 ;`"
                class="actionbtn transbackground_active nice">
                <v-icon color="white">mdi-motion-play-outline</v-icon>
              </div>
              <div
                title="Open Scene Play Conditions"
                v-else-if="
                  Object.keys(
                    deluge.items[scene.did].conditions.play_conditions
                  ).length > 0
                "
                @click="emit('OpenPlayConditions')"
                style="float: left; cursor: pointer"
                class="actionbtn nice"
                :class="scene?.live ? 'actionbtn-live' : 'actionbtn'"
                :style="
                  avg_color ? 'background:' + avg_color : 'background:var(--v-cardColor-base)'
                ">
                <v-icon :color="scene.live ? 'white' : '#ffffff47'">
                  mdi-motion-play-outline
                </v-icon>
              </div>
              <div
                v-if="deluge.items[scene.did].domination_mode > 0 && scene.live"
                @click="emit('OpenPlayConditions')"
                :style="`float: left;cursor:pointer;box-shadow: 0px 0px 8px 8px ${$vuetify.theme.themes.dark.primary}40 ;`"
                class="actionbtn transbackground_active nice">
                <v-icon color="white">mdi-star-shooting</v-icon>
              </div>
              <div
                v-else-if="deluge.items[scene.did].domination_mode > 0"
                @click="emit('OpenPlayConditions')"
                style="float: left; cursor: pointer"
                class="actionbtn nice"
                :style="
                  avg_color ? 'background:' + avg_color : 'background:var(--v-cardColor-base)'
                ">
                <v-icon
                  :color="
                    deluge.items[scene.did].domination_mode > 0
                      ? 'white'
                      : '#ffffff47'
                  ">
                  mdi-star-shooting
                </v-icon>
              </div>
              <!-- Trigger Start -->
              <!-- Trigger Not Live -->
              <div
                v-if="
                  !scene.live && deluge.items[scene.did].triggers.length > 0
                "
                @click="emit('OpenTriggers')"
                style="float: left; cursor: pointer"
                class="actionbtn nice"
                :style="
                  avg_color ? 'background:' + avg_color : 'background:var(--v-cardColor-base)'
                ">
                <v-icon
                  :color="
                    deluge.items[scene.did].triggers.length > 0
                      ? 'white'
                      : '#ffffff47'
                  ">
                  mdi-share-all
                </v-icon>
              </div>
              <!-- Trigger Live -->
              <div
                v-else-if="
                  deluge.items[scene.did].triggers.length > 0 && scene.live
                "
                class="trigger-container">
                <div
                  class="triggers trigger-top-btn transbackground_trigger nice"
                  @click="emit('OpenTriggers')">
                  <v-icon color="white">mdi-share-all</v-icon>
                </div>
                <div
                  @click="emit('OpenTriggers')"
                  class="triggers nice"
                  :style="
                    avg_color ? 'background:' + avg_color : 'background:#171717'
                  ">
                  <v-icon color="white">mdi-share-all</v-icon>
                </div>
              </div>
              <!-- END Triggers -->
            </div>
          </div>
        </div>
      </v-img>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref, watch, defineProps } from 'vue';
import { $http } from '../../stores/http.js';
import { state } from '../../stores/deluge.js';
import { deluge } from '@/stores/deluge.js';
import { getThumbnailForScene } from '../../utils/thumbnails.js';

const props = defineProps([
  'current',
  'scene',
  'channel_id',
  'channel_did',
  'queue',
  'editMode',
]);
const emit = defineEmits(['OpenSceneModal']);
const loading_live = ref(false);
const avg_color = ref(null);
const asset_img = ref('');
function color() {
  return avg_color.value ? avg_color.value : 'var(--v-cardColor-base)';
}
function updateThumbnail() {
  // For queue cards, we need to get the thumbnail from the queue's current/first nested item
  const queueData = deluge.items[props.scene.did];
  if (!queueData) return;

  // NOTE: The items array is on props.scene (the view/reference data), not on queueData (the queue's deluge entry)
  // props.scene contains: { did, items: [...], index, ... }
  // queueData contains: { id, uid, name, svars, scene_name, ... }
  const sceneItems = props.scene.items;
  const sceneIndex = props.scene.index ?? 0;

  // Try to get thumbnail from the currently indexed item in the queue
  if (sceneItems && sceneItems.length > 0) {
    const currentIndex = sceneIndex;
    const currentItem = sceneItems[currentIndex];

    if (currentItem && currentItem.did && deluge.items[currentItem.did]) {
      const nestedItem = deluge.items[currentItem.did];

      // If the nested item is also a queue, recursively look for a scene
      // For nested queues, the items are on currentItem (the reference), not on nestedItem (deluge entry)
      if (nestedItem.type === 'queue' && currentItem.items?.length > 0) {
        const nestedIndex = currentItem.index ?? 0;
        const deepItem = currentItem.items[nestedIndex];

        if (deepItem?.did && deluge.items[deepItem.did]) {
          const deepItemData = deluge.items[deepItem.did];
          const result = getThumbnailForScene(deepItemData, deluge);

          if (result.src || result.color) {
            asset_img.value = result.src;
            avg_color.value = result.color || null;
            return;
          }
        }
      }
      // Otherwise, get thumbnail from the nested item directly (it's a scene, not a queue)
      const result = getThumbnailForScene(nestedItem, deluge);

      if (result.src || result.color) {
        asset_img.value = result.src;
        avg_color.value = result.color || null;
        return;
      }
    }
  }

  // Fallback: try the queue itself (shouldn't have svars but just in case)
  const result = getThumbnailForScene(queueData, deluge);
  asset_img.value = result.src || '';
  avg_color.value = result.color || null;
}

watch(
  () => props.scene,
  () => {
    updateThumbnail();
  }
);

// Watch for changes to deluge.items to handle initial load and updates
watch(
  () => deluge.items[props.scene.did],
  () => {
    updateThumbnail();
  },
  { deep: true }
);

onMounted(() => {
  updateThumbnail();
});

function FindFirstAsset(scene) {
  const result = getThumbnailForScene(scene, deluge);
  asset_img.value = result.src;
  avg_color.value = result.color || null;
}
async function force_scene() {
  loading_live.value = true;
  try {
    await $http(
      'GET',
      '/dynamic_engine/go_live?did=' +
        props.scene.did +
        '&channel_id=' +
        props.channel_id
    );
    loading_live.value = false;
  } catch (error) {
    console.log(error);
  }
}
</script>

<style scoped lang="scss">
#cont {
  position: absolute;
  width: 210px;
  height: 100%;
  text-align: center;
  overflow: hidden;
  border-radius: 4px;
}
.actionbtn {
  width: 100%;
  height: 32px;
  cursor: pointer;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}
.actionbtn {
  width: 100%;
  height: 32px;
  cursor: pointer;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-container {
  bottom: 0;
  display: inline-block;
  width: 100%;
  display: flex;
  justify-content: stretch;
  gap: 4px;
}

// Triggers

.trigger-container {
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
  height: 32px;
}

.triggers {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.trigger-top-btn {
  // This one fades out
  position: absolute;
  opacity: 0;
}

.grabber {
  display: inline-block;
  border-radius: 3px 0px 0px 3px;

  height: 92px;
  width: 32px;
  cursor: grab;
}
@keyframes fade-out {
  from {
    background: var(--v-primary-base);
    opacity: 1;
    z-index: 10;
  }
  to {
    background-color: rgba(0, 0, 0, 0);
    opacity: 0;
    z-index: -1;
  }
}
.transbackground_trigger {
  animation-name: fade-out;
  animation-duration: 2.5s;
  animation-timing-function: ease-in;
}
.template-icon {
  transition:
    opacity 0.15s ease-in-out,
    margin 0.25s ease-in-out;
}
</style>
